import { DEFAULT_PATHS } from 'routes/paths';

export const BUSINESS_APPS_PATH = DEFAULT_PATHS.BUSINESS_APPS;

export const businessAppDetailsUrl = (
  apiName: string,
  previewOwnerId?: string | null,
  subpath = ''
) =>
  `${BUSINESS_APPS_PATH}/apps/${apiName}${subpath}${
    previewOwnerId ? `?preview_owner=${previewOwnerId}` : ''
  }`;

export const KIZEN_CLI = 'npx -y @kizenapps/cli@latest';

const KIZEN_CLI_ENVIRONMENTS: Record<string, string> = {
  'app.go.kizen.com': 'go',
  'app.fmo.kizen.com': 'fmo',
  'staging.kizen.com': 'staging',
  'integration.kizen.dev': 'integration',
  'app.test1.kizen.dev': 'test1',
};

const API_BASE_PATH: string = import.meta.env.VITE_API_BASE_PATH ?? '';

const API_HOST = API_BASE_PATH.match(/^https?:\/\/([^/]+)/)?.[1] ?? '';

const KIZEN_CLI_ENV = KIZEN_CLI_ENVIRONMENTS[API_HOST] ?? 'go';

export const BUSINESS_APPS_DEVELOPER_DOCS_URL =
  'https://developer.kizen.com/docs/integrations-and-apps/plugin-development';

// Production is the CLI default
const ENV_FLAG = KIZEN_CLI_ENV === 'go' ? '' : ` --env ${KIZEN_CLI_ENV}`;

export const KIZEN_SETUP_COMMANDS = {
  login: `${KIZEN_CLI} login${ENV_FLAG}`,
  connect: `${KIZEN_CLI} setup-claude --mcp${ENV_FLAG}`,
};

// For the coding agent, so not translated
export const KIZEN_SETUP_PROMPT = [
  `Set up Kizen for me. Run ${KIZEN_SETUP_COMMANDS.login} and I'll approve the sign-in in my browser. Then run ${KIZEN_SETUP_COMMANDS.connect} to connect Kizen to this agent.`,
  'When I ask you to build or change a Business App, push it as a preview first. Before you push anything, tell me how it will be deployed and get my OK. Never publish unless I ask.',
].join('\n');
